import { z } from "zod";

export const CSV_IMPORT_TYPE_VALUES = [
  "ITEMS",
  "PRICE_LIST_LINES",
  "COMPANIES",
  "EXCHANGE_RATES",
  "OPERATIONS",
  "USERS",
] as const;
export const CsvImportTypeSchema = z.enum(CSV_IMPORT_TYPE_VALUES);
export type CsvImportType = z.infer<typeof CsvImportTypeSchema>;
export const CSV_IMPORT_TYPE = CsvImportTypeSchema.enum;

export const CSV_IMPORT_STATUS_VALUES = [
  "QUEUED",
  "PROCESSING",
  "COMPLETE",
  "FAILED",
] as const;
export const CsvImportStatusSchema = z.enum(CSV_IMPORT_STATUS_VALUES);
export type CsvImportStatus = z.infer<typeof CsvImportStatusSchema>;
export const CSV_IMPORT_STATUS = CsvImportStatusSchema.enum;

export const CsvImportSummarySchema = z.object({
  totalRows: z.number(),
  createdCount: z.number(),
  updatedCount: z.number(),
});
export type CsvImportSummary = z.infer<typeof CsvImportSummarySchema>;

export const CsvImportResponseSchema = z.object({
  id: z.string(),
  importType: CsvImportTypeSchema,
  status: CsvImportStatusSchema,
  fileName: z.string().nullable(),
  errorMessage: z.string().nullable(),
  summary: CsvImportSummarySchema.nullable(),
  createdAt: z.coerce.date(),
});
export type CsvImportResponse = z.infer<typeof CsvImportResponseSchema>;

export const CreateCsvImportRequestSchema = z.object({
  importType: CsvImportTypeSchema,
  assetId: z.string(),
  fileName: z.string(),
});
export type CreateCsvImportRequest = z.infer<
  typeof CreateCsvImportRequestSchema
>;

/** Maps each import type to its template CSV filename for download. */
export const CSV_IMPORT_TEMPLATE_FILENAME: Record<CsvImportType, string> = {
  ITEMS: "items_template.csv",
  PRICE_LIST_LINES: "price_list_lines_template.csv",
  COMPANIES: "companies_template.csv",
  EXCHANGE_RATES: "exchange_rates_template.csv",
  OPERATIONS: "operations_template.csv",
  USERS: "users_template.csv",
};
